const IMAGES = [
  {
    src: "https://images.pexels.com/photos/20088977/pexels-photo-20088977.jpeg",
    label: "Residential Plow · Westboro",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1774296690468-4bfb6aec8c95",
    label: "Sealed Asphalt · Kanata",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/11412887/pexels-photo-11412887.jpeg",
    label: "Storm Night · Centretown",
    span: "",
  },
  {
    src: "https://images.pexels.com/photos/35030442/pexels-photo-35030442.jpeg",
    label: "Commercial Lot · Orleans",
    span: "lg:col-span-2",
  },
  {
    src: "https://static.prod-images.emergentagent.com/jobs/ed2227e8-f42f-486d-80b3-32e833e48098/images/c8c14ae2f286872a6e4bfdf2bf3e19277e0965c95433164e9aa87cbe2fc1e47f.png",
    label: "Fresh Sealcoat · Macro",
    span: "",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 md:py-32 bg-[#070F1C]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="hairline mb-6">The Work</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-2xl">
              Built for Ottawa,
              <span className="text-[#C9A24B]"> proven on it.</span>
            </h2>
          </div>
          <p className="text-white/65 max-w-md text-base">
            A few recent jobs from across the city — quiet mornings after storms, deep-black
            driveways after a fresh seal.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:auto-rows-[200px]">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative group overflow-hidden border border-white/10 ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.label}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14] via-[#050B14]/20 to-transparent opacity-90" />
              <figcaption className="absolute bottom-3 left-4 right-4 text-[11px] tracking-[0.2em] uppercase text-white/85 font-medium">
                {img.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
